import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { DriverService } from '../../../services/DriverService';
import { GetDriverListPagingAndFilterRequest, initialGetDriverListPagingAndFilterRequest } from '../../../models/request/driver/GetDriverListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetDriverListPagingAndFilterResponse, GetDriverListPagingAndFilterResponseData, GetDriverListPagingAndFilterResponseItem, initialGetDriverListPagingAndFilterResponseData } from '../../../models/response/driver/GetDriverListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { DeleteDriverResponse } from '../../../models/response/driver/DeleteDriverResponse';
import DriverListFilters from './Components/DriverListFilters';
import { ExportDriverListResponse } from '../../../models/response/driver/ExportDriverListResponse';
import { MrzResponse } from '../../../models/response/mrz/MrzResponse';
import { AddDriverByMrzResponse } from '../../../models/response/driver/AddDriverByMrzResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { CompanyService } from '../../../services/CompanyService';

const DriverList = () => {
    const socketRef = useRef<WebSocket | null>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > Sürücü Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetDriverListPagingAndFilterResponseData>(initialGetDriverListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetDriverListPagingAndFilterRequest>(initialGetDriverListPagingAndFilterRequest)
    const [isListening, setIsListening] = useState(false);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Adı', name: 'name', order: 0, isVisible: true },
            { title: 'Soyadı', name: 'surname', order: 0, isVisible: true },
            { title: 'T.C. Kimlik No', name: 'tckn', order: 0, isVisible: true },
            { title: 'Bağlı Olduğu Firma', name: 'relatedCompanyName', order: 0, isVisible: true },
            { title: 'Telefon 1', name: 'phone1', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, []);

    useEffect(() => {
        return () => {
            if (socketRef.current) {
                socketRef.current.close();
            }
        };
    }, []);

    const deleteDriver = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.driverId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteDriverResponse = await DriverService.deleteDriver(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateDriver = async (_id: string | undefined = undefined) => {
        navigate('/driver/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].driverId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetDriverListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetDriverListPagingAndFilterResponse = await DriverService.getDriverListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.driverId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportDriverListResponse = await DriverService.exportDriverList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.driverId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Listedeki kolonların tamamının
    // veritabanında karşılığı olduğu için hepsi sıralanabilir.
    const sortableColumns = [
        'name', 'surname', 'tckn', 'relatedCompanyName',
        'phone1', 'isCustomActive', 'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (DriverManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        name: { type: 'text' },
        surname: { type: 'text' },
        tckn: { type: 'text' },
        relatedCompanyName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        phone1: { type: 'text' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetDriverListPagingAndFilterResponseItem, column: string, index: number) => {
        if (column == "isCustomActive") {
            return (
                <td onClick={() => setItemSelected(item.driverId)} onDoubleClick={() => updateDriver(item.driverId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td onClick={() => setItemSelected(item.driverId)} onDoubleClick={() => updateDriver(item.driverId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td onClick={() => setItemSelected(item.driverId)} onDoubleClick={() => updateDriver(item.driverId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td onClick={() => setItemSelected(item.driverId)} onDoubleClick={() => updateDriver(item.driverId)}>{item2[column]}</td>;
        }
    }

    const mrzNfcHandler = async () => {
        if (socketRef.current) {
            return;
        }

        setIsListening(true);

        const socket = new WebSocket(Helpers.getWsEndpoint() + '/ws');
        socketRef.current = socket;

        socket.onopen = () => {
            socket.send("MRZ-" + auth.user.user?.data.id);
        };

        socket.onmessage = async (event) => {
            try {
                setIsListening(false);
                dispatch(storeActivityIndicator(true));
                const data: MrzResponse = JSON.parse(event.data);
                socket.close();
                var response: AddDriverByMrzResponse = await DriverService.addDriverByMrz(data);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                getData();
            } catch (error: any) {
                toast.error(error);
                dispatch(storeActivityIndicator(false));
            }
        };

        socket.onclose = () => {
            socketRef.current = null;
            setIsListening(false);
        };

        socket.onerror = (error) => {
        };
    }

    const disconnectSocket = () => {
        if (socketRef.current) {
            socketRef.current.close();
            socketRef.current = null;
        }
    };

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <DriverListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    mrzNfcHandler={mrzNfcHandler}
                    isListening={isListening}
                    disconnectSocket={disconnectSocket}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteDriver}
                    updateFunction={updateDriver}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.driverId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default DriverList;